import React, { useState } from 'react';
import './Temporadas/Temporadas.css';
import { hoyIso } from '../utils/calendarioUtils';

const OPCIONES = (partido) => [
  ['LOCAL', `Equipo local (${partido.local_nombre})`],
  ['VISITANTE', `Equipo visitante (${partido.visitante_nombre})`],
  ['AMBOS', 'Ambos equipos'],
  ['LESION', 'Lesión'],
];

// Registra un aplazamiento: motivo, quién lo motiva (de ello depende el estado
// que ve el jugador y a quién se avisa) y la fecha en que se comunicó. Solo
// ADMIN/COMITE (el backend lo exige).
export default function ModalAplazar({ partido, onConfirmar, onCerrar }) {
  const [motivo, setMotivo] = useState('');
  const [aplazadoPor, setAplazadoPor] = useState('');
  const [fecha, setFecha] = useState(hoyIso());
  const [guardando, setGuardando] = useState(false);
  const [error, setError] = useState(null);

  const valido = motivo.trim() !== '' && aplazadoPor !== '' && fecha !== '';

  const enviar = async (e) => {
    e.preventDefault();
    setGuardando(true);
    setError(null);
    try {
      await onConfirmar({ motivo: motivo.trim(), aplazadoPor, fechaComunicacion: fecha });
    } catch (err) {
      setError(err.message || 'No se pudo aplazar el partido.');
      setGuardando(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={(e) => e.target === e.currentTarget && !guardando && onCerrar()}>
      <form className="modal-box" role="dialog" aria-modal="true" aria-labelledby="aplazar-titulo" onSubmit={enviar}>
        <h3 id="aplazar-titulo">Aplazar partido</h3>
        <p className="modal-partido" style={{ color: 'var(--c-muted)', marginTop: 0 }}>{partido.local_nombre} vs {partido.visitante_nombre} · jornada {partido.jornada}</p>
        {error && <p className="error-msg" role="alert">{error}</p>}

        <div className="form-row">
          <label htmlFor="aplazar-por">¿Quién aplaza?</label>
          <select id="aplazar-por" value={aplazadoPor} onChange={(e) => setAplazadoPor(e.target.value)} autoFocus>
            <option value="">— elige —</option>
            {OPCIONES(partido).map(([valor, etiqueta]) => <option key={valor} value={valor}>{etiqueta}</option>)}
          </select>
        </div>
        <div className="form-row">
          <label htmlFor="aplazar-motivo">Motivo</label>
          <input id="aplazar-motivo" value={motivo} onChange={(e) => setMotivo(e.target.value)} />
        </div>
        <div className="form-row">
          <label htmlFor="aplazar-fecha">Fecha en que se comunicó el aplazamiento</label>
          <input id="aplazar-fecha" type="date" value={fecha} onChange={(e) => setFecha(e.target.value)} />
        </div>

        <div className="modal-footer">
          <button type="button" className="btn btn-secondary" disabled={guardando} onClick={onCerrar}>Cancelar</button>
          <button type="submit" className="btn btn-primary" disabled={!valido || guardando}>
            {guardando ? 'Aplazando…' : 'Aplazar'}
          </button>
        </div>
      </form>
    </div>
  );
}
